import Vue from 'vue'
import App from './App.vue'

// our routing strategy
import router from './router';

// import global filters
import * as filters from './utils';

// register global utility filters
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});

import fullscreen from 'vue-fullscreen'
Vue.use(fullscreen)

// VueJS Modal
import VModal from 'vue-js-modal';
Vue.use(VModal, { dialog: true })

Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
